import { encodeSVG, getScaledSvgViewBox } from './vectorImage'
import type { ParsedSvg } from './vectorImage/typing'

export const getSvgCssVarName = (svgId: string) => `--svg-${svgId.replace(/\.svg$/, '')}`

export const createSvgCssVar = (svgId: string, svg: ParsedSvg | undefined): string | undefined => {
	if (!svg?.content) {
		return undefined
	}

	const stretchedSvg = getScaledSvgViewBox(svg.content, svg.info, { displayMode: 'stretch' })
	const encodedSvg = encodeSVG(stretchedSvg)

	return `${getSvgCssVarName(svgId)}:${encodedSvg};`
}
